<div class="locale">
    <!-- Icons -->
    <mat-icon class="locale__icon" *ngIf="showIcon">language</mat-icon>
    <!-- The Angular Model here is directly piped to the i18nService -->
    <mat-select class="locale__select" [hideSingleSelectionIndicator]="true" (ngModelChange)="onChange($event)" [(ngModel)]="i18nService.selectedLocaleId">
      <mat-option *ngFor="let locale of nativeLocales | keyvalue:valueAscendingOrder" [value]="locale.key" >
        <app-text-with-logo 
            data-test-id="logo"
            [logo]="'./assets/' + locale.key + '.png'"
            [text]="locale.value"
            [size]="'small'"
        />
      </mat-option>
    </mat-select>
</div>
